module.exports = __webpack_public_path__ + "static/media/p1_3.d48693de.png";